import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./index.scss";
import ja from "date-fns/locale/ja";

registerLocale("ja", ja);

const CustomDatePicker = React.forwardRef((props, ref) => {
  const {
    className,
    option,
    name,
    onChange,
    dataName,
    showTimeSelect,
    timeIntervals,
    id,
    dateFormat,
    ...otherProps
  } = props;

  const [selectedDate, setSelectedDate] = React.useState(null); // date only

  // Initialize from option
  React.useEffect(() => {
    if (option?.selectedDate) {
      const dateObj = new Date(option.selectedDate);
      setSelectedDate(new Date(dateObj));
    } else {
      setSelectedDate(null);
    }
  }, [option?.selectedDate]);

  const handleChange = (date) => {
    if (date) {
      setSelectedDate(date);
      onChange(date);
    }
  };

  return (
    <div
      className={`custom-react-datepicker-container w-full d-flex ${
        option?.disabled ? "cursor-default" : "cursor-pointer"
      }`}
    >
      {/* Date Picker */}
      <DatePicker
        id={id + "-date"}
        data-name={dataName}
        name={name}
        locale="ja"
        className={`${className} w-70`}
        selected={selectedDate}
        onChange={handleChange}
        dateFormat={dateFormat?.split(" ")[0]}
        placeholderText={option?.placeholder}
        maxDate={new Date(9999, 11, 31)}
        disabled={!!option?.disabled}
        autoComplete="off"
        {...otherProps}
      />

      {/* Time Picker */}
      {showTimeSelect && (
        <DatePicker
          id={id + "-time"}
          className={`${className} ms-2`}
          selected={selectedDate}
          onChange={handleChange}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={timeIntervals || 1}
          timeCaption="時間"
          dateFormat="HH:mm a"
          disabled={!!option?.disabled}
          autoComplete="off"
          locale="ja"
          {...otherProps}
        />
      )}
    </div>
  );
});

CustomDatePicker.displayName = "CustomDatePicker";
export default CustomDatePicker;
